import { FormControl } from '@angular/forms';
import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { AudienceRolesStorage } from './audience-roles-storage';
import { map } from 'rxjs/operators';

@Component({
    selector: 'audience-roles-select',
    template: require('./audience-roles-select.component.html'),
    styles: [require('./audience-roles-select.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AudienceRolesSelectComponent {
    @Input() 
    public control: FormControl;

    public readonly audienceRoles$: Observable<string[]>;

    constructor(audienceRolesStorage: AudienceRolesStorage) {
        this.audienceRoles$ = audienceRolesStorage.external
            .pipe(map(audienceRoles => audienceRoles
                ? audienceRoles.map(audienceRole => audienceRole.name)
                : []
            ));
    }

    public onChangedRoles(roles: string[]) {
        this.control.setValue(roles);
    }
}
